module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"link":"原文を見る"}}')
  delete Component.options._Ctor
}
